import { render, staticRenderFns } from "./CollarLeashGroup.vue?vue&type=template&id=5bd99391&scoped=true&"
import script from "./CollarLeashGroup.vue?vue&type=script&lang=js&"
export * from "./CollarLeashGroup.vue?vue&type=script&lang=js&"
import style0 from "./CollarLeashGroup.vue?vue&type=style&index=0&id=5bd99391&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd99391",
  null
  
)

export default component.exports